export default __webpack_public_path__ + "static/media/DTproto2.cecaf02f.jpg";